import { Injector } from '@angular/core';
import {
	FormioCustomComponentInfo,
	registerCustomFormioComponent,
} from 'dp-formio';
import { ReviewingEvaluationWrapperComponent } from './reviewing-evaluation-wrapper.component';

const COMPONENT_OPTIONS: FormioCustomComponentInfo = {
	type: 'reviewing-evaluation',
	selector: 'reviewing-evaluation',
	title: 'reviewing-evaluation',
};

export function registerReviewingEvaluationComponent(injector: Injector) {
	registerCustomFormioComponent(COMPONENT_OPTIONS, ReviewingEvaluationWrapperComponent, injector);
}
